<template>
  <div class="container z-grid v-page-section-container-padding-wide-screens" :class="'t-' + colorTheme">
    <div class="z-grid__cols z-grid__content sm:rounded-3xl" :class="backgroundColor">
      <div class="prose prose--app" :class="mobileTheme ? `prose--app--${mobileTheme} sm:prose--app--${colorTheme}` : `prose--app--${colorTheme}`" v-html="description"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  description: { type: String, required: true },
  backgroundColor: { type: String, required: false, default: 'bg-white' },
  colorTheme: { type: String, required: false, default: undefined },
  mobileTheme: { type: String, required: false, default: undefined },
})
</script>
